var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTickSquare = function SvgTickSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#578A1D",
    d: "M10.792 1.333H5.205c-2.426 0-3.873 1.447-3.873 3.874v5.58c0 2.433 1.447 3.88 3.873 3.88h5.58c2.427 0 3.874-1.447 3.874-3.874V5.207c.006-2.427-1.44-3.874-3.867-3.874Zm.393 5.134-3.78 3.78a.5.5 0 0 1-.706 0L4.812 8.36a.503.503 0 0 1 0-.707.503.503 0 0 1 .707 0l1.533 1.534 3.427-3.427a.503.503 0 0 1 .706 0 .503.503 0 0 1 0 .707Z"
  })));
};
export default SvgTickSquare;